import React, { useState } from 'react'
import Logo from '../assets/logo.png';
import { NavLink, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { PiDownloadDuotone } from 'react-icons/pi';

const Header = () => {
const [showNav, setShowNav] = useState(false);
const navigate = useNavigate();

  return (
    <>
                <div className="top-header">
                    <div className="top-left"> Kamapalli Main Rd, near to Tata Benz, Chhak, Kamapalli, Brahmapur, Odisha 760004</div>
                    <div className="top-right">
                        <Link to="" > kcpublicschool@gmail.com </Link>  {/*target='_blank'*/}
                        <Link to='' ><i className="fab fa-instagram"></i></Link>
                        <Link to='' ><i class="fa-brands fa-linkedin"></i></Link>
                        <Link to='' ><i class="fa-brands fa-square-facebook"></i></Link>
                        <Link to='' ><i class="fa-brands fa-square-whatsapp"></i></Link>
                    </div>

                </div>
      {/* Header section */}
<section className='py-md-2 py-1'>
    <div className='container d-flex justify-content-between'>

<img src={Logo} className='header-logo' alt='Logo' />

<div className='align-content-center d-lg-block d-none'>
    <NavLink className='nav-text' activeClassName="active" to='/' >Home</NavLink>
    <NavLink className='nav-text' activeClassName="active" to='/about' >About Us</NavLink>
    <NavLink className='nav-text' activeClassName="active" to='/academics' >Academics</NavLink>
    <NavLink className='nav-text' activeClassName="active" to='/achievements' >Achievements</NavLink>
    <NavLink className='nav-text' activeClassName="active" to='/contact' >Contact</NavLink>

    <button className='btn text-light fw-semibold' style={{backgroundColor: 'var(--ins4)'}} onClick={() => navigate('/student-registration')}>Register Now</button>
                        <button className='btn text-light fw-semibold ms-2' style={{backgroundColor: 'var(--ins4)'}} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.dectwin.parent_app', '_blank')}><PiDownloadDuotone /> Student App</button>
</div>

<div className='d-lg-none d-flex'>
<button className='d-lg-none d-block align-content-center nav-btn my-4 me-2' onClick={()=> setShowNav(true)}><i class="fa-solid fa-bars"></i></button>
                        <button className='d-lg-none d-block align-content-center nav-btn my-4' style={{backgroundColor: 'var(--ins4)'}} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.dectwin.parent_app', '_blank')}><PiDownloadDuotone /> Student App</button>
</div>


    </div>
</section>
      {/* Header section ends */}


{showNav && (
    <>
    <section className='nav-area animate__animated animate__fadeInUp'>
        <span className='float-end' onClick={() => setShowNav(false)}><i class="fa-solid fa-circle-xmark close-btn"></i></span><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName="active" to='/' >Home</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName="active" to='/about' >About Us</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName="active" to='/academics' >Academics</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName="active" to='/achievements' >Achievements</NavLink><br /><br />
    <NavLink className='nav-text' onClick={() => setShowNav(false)} activeClassName="active" to='/contact' >Contact</NavLink><br /><br />
    <button className='btn text-light fw-semibold' style={{backgroundColor: 'var(--ins4)'}} onClick={() => {navigate('/student-registration'); setShowNav(false)}}>Register Now</button>
<img src={Logo} className='nav-logo' alt='Logo' />
    </section>
    </>
)}

    </>
  )
}

export default Header
